<template>
  <md-card class="md-layout-item md-size-100 md-small-size-100">
    <md-card-header>
      <div class="md-title">Automatically generated numbers</div>
      <span class="md-caption">Create, Modify, Delete your autonumbers</span>
    </md-card-header>
    <md-card-content>
      <md-button
        class="md-dense md-layout-item md-raised"
        @click="fetchAutonumbers"
      >Refresh
      </md-button>
      <md-button
        class="md-dense md-layout-item md-raised md-primary"
        @click="showEditDialog(null)"
      >New Autonumber
      </md-button>
    </md-card-content>
    <md-progress-bar
      md-mode="indeterminate"
      v-if="inProgress"
    />
    <md-table
      md-sort="updated_on"
      md-sort-order="desc"
    >
      <md-table-row>
        <md-table-head>
          Modify / Delete</md-table-head>
        <md-table-head>Autonumber ID</md-table-head>
        <md-table-head>Name</md-table-head>
        <md-table-head>Template</md-table-head>
        <md-table-head>Current Value</md-table-head>
      </md-table-row>
      <md-table-row
        v-for="autonumber in autonumbers"
        v-bind:key="autonumber.id"
      >
        <md-table-cell>
          <md-button
            class="md-icon-button md-dense"
            @click="showEditDialog(autonumber)"
          >
            <md-icon class="pointer">edit</md-icon>
          </md-button>
          <md-button
            class="md-icon-button md-dense"
            @click="deleteAutonumber(autonumber.id)"
          >
            <md-icon>delete</md-icon>
          </md-button>
        </md-table-cell>
        <md-table-cell>
          {{autonumber.id}}
        </md-table-cell>
        <md-table-cell><b>{{autonumber.name}}</b></md-table-cell>
        <md-table-cell><b>{{autonumber.template}}</b></md-table-cell>
        <md-table-cell>{{autonumber.last_value}}</md-table-cell>
      </md-table-row>
    </md-table>
    <md-card-actions>
    </md-card-actions>
    <p class="md-caption">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; You may use automatically generated numbers to update properties of your entities using unique values generated from a template.</p>
    <br />
    <md-dialog-alert
      :md-active.sync="errorDialogShow"
      :md-content="errorMsg"
      md-confirm-text="Ok"
    />
    <md-dialog :md-active.sync="editDialogShow">
      <md-dialog-title v-if="id">
        Edit autonumber
      </md-dialog-title>
      <md-dialog-title v-else>
        Add autonumber
      </md-dialog-title>
      <md-content>
        <md-field>
          <label>Name</label>
          <md-input
            md-counter="64"
            v-model="name"
          ></md-input>
        </md-field>
        <md-field>
          <label>Template</label>
          <md-input
            md-counter="64"
            v-model="template"
          ></md-input>
        </md-field>
      </md-content>
      <md-dialog-actions>
        <md-button
          class="md-primary"
          @click="editDialogShow = false"
        >CANCEL</md-button>
        <md-button
          v-if="id"
          class="md-accent"
          @click="upsertAutonumber()"
          :disabled="disableUpsertBtn"
        > UPDATE </md-button>
        <md-button
          v-else
          class="md-accent"
          @click="upsertAutonumber()"
          :disabled="disableUpsertBtn"
        > ADD </md-button>
      </md-dialog-actions>
    </md-dialog>
  </md-card>
</template>
<script>
import axios from "axios";
const BASE_URL = process.env.VUE_APP_FUNCTIONURL;
export default {
  name: "Autonumber",
  data: () => ({
    autonumbers: [],
    company: "",
    errorMsg: "",
    errorDialogShow: false,
    editDialogShow: false,
    name: "",
    template: "",
    id: "",
    disableUpsertBtn: false,
    inProgress: false,
  }),
  created: function () {
    this.company = this.$route.params.company;
    this.fetchAutonumbers();
  },
  methods: {
    callApi(url, body, success, errMsg) {
      (body ? axios.post(url, body) : axios.get(url))
        .then((response) => success(response))
        .catch((error) => {
          this.errorMsg = errMsg;
          this.errorDialogShow = true;
          console.log(errMsg + "\n" + error);
        });
    },
    addAutonumber() {},
    upsertAutonumber() {
      this.disableUpsertBtn = true;
      this.callApi(
        `${BASE_URL}/api/autonumber?company=${this.company}`,
        {
          id: this.id,
          name: this.name,
          template: this.template,
        },
        (response) => {
          this.disableUpsertBtn = false;
          this.fetchAutonumbers();
          this.editDialogShow = false;
        },
        "Error happened while saving autonumber"
      );
    },
    showEditDialog(autonum) {
      this.disableUpsertBtn = false;
      if (autonum) {
        this.id = autonum.id;
        this.name = autonum.name;
        this.template = autonum.template;
      } else {
        this.id = null;
        this.name = "new autonumber";
        this.template = "[00000]";
      }
      this.editDialogShow = true;
    },
    fetchAutonumbers() {
      this.inProgress = true;
      this.callApi(
        `${BASE_URL}/api/autonumber-list?company=${this.company}`,
        null,
        (response) => {
          this.inProgress = false;
          this.autonumbers = response.data.autonumbers;
        },
        "Error happened while loading list of autonumbers"
      );
    },
    deleteAutonumber(id) {
      this.inProgress = true;
      axios
        .delete(`${BASE_URL}/api/autonumber?company=${this.company}&id=${id}`)
        .then((response) => {
          this.fetchAutonumbers();
          console.log(response);
        })
        .catch((error) => {
          this.inProgress = false;
          this.errorMsg = errMsg;
          this.errorDialogShow = true;
          console.log(errMsg + "\n" + error);
        });
    },
  },
};
</script>
